import React from 'react';
import { Table } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
export var AppSimpleTable = function (_a) {
    var tableHeader = _a.tableHeader, tableData = _a.tableData, className = _a.className, settings = _a.settings;
    var ths = tableHeader.map(function (item) { return item; });
    var emptyDataMessage = (React.createElement("tr", null,
        React.createElement("td", { className: 'text-center', colSpan: ths.length },
            React.createElement(FormattedMessage, { id: 'table.nodata' }))));
    var data = tableData && tableData.length > 0 ? tableData : emptyDataMessage;
    var tableClassName = className ? className : '';
    return (React.createElement(Table, { className: "app-table ".concat(tableClassName), hover: true },
        React.createElement("thead", null,
            React.createElement("tr", { className: 'table-tr_color' }, ths)),
        React.createElement("thead", { className: 'thead-settings' }, settings),
        React.createElement("tbody", null, data)));
};
//# sourceMappingURL=app-simple-table.js.map